import "../commoncss/Loader.css";

const Loader = ({ loading }) => {
  if (!loading) return null;

  return <span className="loader"></span>;
};

export default Loader;
